import { ErrorMessage, Field } from "formik";

import React from "react";
import { AlertCircle } from "lucide-react";

const FilterTextField = ({
  label = "Field Label",
  labelClassName = "",
  name = "textField",
  className = "",
  placeholder = "",
  type = "text",
  required = false,
  icon: Icon,
  ...props
}) => {
  return (
    <div className={`w-full ${className}`}>
      <Field name={name}>
        {({ field, meta }) => {
          const hasError = Boolean(meta.touched && meta.error);

          return (
            <div className="flex flex-col gap-1.5 w-full">
              {/* Field Label */}
              {label && (
                <label
                  htmlFor={name}
                  className={`block text-xs font-semibold tracking-wide uppercase transition-colors ${
                    hasError ? "text-red-500" : "text-gray-600"
                  } ${labelClassName}`}
                >
                  {label}
                  {required && <span className="ml-0.5 text-red-500">*</span>}
                </label>
              )}

              {/* Input Wrapper */}
              <div className="relative flex items-center w-full rounded-lg shadow-sm">
                {Icon && (
                  <div className="absolute left-3 pointer-events-none text-gray-400">
                    <Icon className="h-4 w-4" />
                  </div>
                )}

                <input
                  {...field}
                  {...props}
                  id={name}
                  type={type}
                  placeholder={placeholder}
                  required={required}
                  className={`w-full rounded-lg border bg-white py-2 text-sm text-gray-900 placeholder:text-gray-400 transition-all duration-150 focus:outline-none ${
                    Icon ? "pl-9 pr-3" : "px-3"
                  } ${
                    hasError
                      ? "border-red-300 focus:border-red-500 focus:ring-2 focus:ring-red-500/20"
                      : "border-gray-200 hover:border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20"
                  }`}
                />

                {hasError && !Icon && (
                  <div className="absolute right-3 pointer-events-none text-red-500">
                    <AlertCircle className="h-4 w-4" />
                  </div>
                )}
              </div>

              {/* Error Message Container */}
              <div className="min-h-[1.125rem] px-0.5">
                <ErrorMessage name={name}>
                  {(msg) => (
                    <span className="flex items-center gap-1 text-xs font-medium text-red-500">
                      {msg}
                    </span>
                  )}
                </ErrorMessage>
              </div>
            </div>
          );
        }}
      </Field>
    </div>
  );
};

export default FilterTextField;
